import mergeDescriptors from 'merge-descriptors';
import merge from 'lodash/merge.js';
import omit from 'lodash/omit.js';
import each from 'lodash/each.js';
import map from 'lodash/map.js';
import commonInca from './incaObjects/common.js';
import errandInca from './incaObjects/errand.js';
import startpageGenerator from './incaObjects/startpage.js';
const createRegvarForMetadata = (metadata, regvar, termId)=>{
    metadata.regvars[regvar.shortname] = {
        term: termId,
        description: regvar.description || regvar.label || regvar.shortname,
        technicalName: regvar.technicalName || `T${termId}`,
        sortOrder: 0,
        label: regvar.label || regvar.shortname,
        compareDescription: regvar.compareDescription || regvar.description || regvar.label || regvar.shortname,
        isComparable: true,
        ...omit(regvar, [
            'shortname'
        ])
    };
};
const createTermForMetadata = (metadata, regvarDefinition, termId)=>{
    metadata.terms[termId] = {
        description: '',
        name: `Term for ${regvarDefinition.shortname}`,
        shortname: `T_${regvarDefinition.shortname}`,
        ...omit(regvarDefinition, [
            'shortname',
            'description',
            'technicalName',
            'compareDescription',
            'label'
        ])
    };
};
const createDummyListValues = (lists)=>{
    let n = 0;
    each(lists, (list)=>{
        n++;
        each(list, (opt, i)=>{
            if (!Object.prototype.hasOwnProperty.call(opt, 'id')) {
                opt.id = n * 10000 + i;
            }
        });
    });
    return lists;
};
const createDummyForm = function(db) {
    const form = {};
    let treeLevel = 1;
    form.env = {
        _PERSNR: '19111111-1111',
        _FIRSTNAME: 'Test',
        _SURNAME: 'Testsson',
        _INREPNAME: 'Rapportör Rapportörsson',
        _INUNITNAME: 'OC Demo (0)',
        _SEX: 'M',
        _ADDRESS: 'Testgatan 1',
        _POSTALCODE: '12345',
        _CITY: 'Teststad',
        _LKF: '123456',
        _SECRET: false,
        _DATEOFDEATH: '',
        _REPORTERNAME: '',
        _LAN: '12',
        _KOMMUN: '34',
        _FORSAMLING: '56',
        _PATIENTID: 1
    };
    const metadata = {}, data = {};
    let termNumber = Math.round(Math.random() * 1000);
    const addTable = (table, values, tl)=>{
        data[table] = {
            regvars: {},
            subTables: {},
            vdlists: {}
        };
        metadata[table] = {
            regvars: {},
            vdlists: {},
            subTables: [],
            terms: {},
            treeLevel: tl
        };
        each([
            'regvars',
            'vdlists'
        ], (type)=>{
            each(values[type] || {}, (val, name)=>{
                termNumber++;
                data[table][type][name] = {
                    include: true,
                    value: null
                };
                metadata[table][type][name] = {
                    term: termNumber,
                    label: name
                };
                if (Array.isArray(val)) {
                    metadata[table][type][name].listValues = map(val, (x)=>{
                        return typeof x === 'object' ? x : {
                            id: x,
                            value: x,
                            text: x
                        };
                    });
                    metadata[table][type][name].dataType = 'list';
                    metadata[table].terms[termNumber] = {
                        description: 'term for ' + name,
                        dataType: 'list',
                        listValues: map(val, (x)=>{
                            return typeof x === 'object' ? x : {
                                id: x,
                                value: x,
                                text: x
                            };
                        })
                    };
                } else if (val.term) {
                    metadata[table].terms[termNumber] = val.term;
                } else {
                    metadata[table][type][name].description = 'regvarMetadata for ' + name;
                    metadata[table][type][name].dataType = val;
                    metadata[table].terms[termNumber] = {
                        description: 'term for ' + name,
                        dataType: val
                    };
                }
            });
        });
        each(values.subTables || {}, (childValues, childTable)=>{
            metadata[table].subTables.push(childTable);
            data[table].subTables[childTable] = [];
            addTable(childTable, childValues, tl + 1);
            treeLevel++;
        });
    };
    addTable(db.rootTable, {
        regvars: db.regvars,
        subTables: db.subTables
    }, treeLevel);
    form.metadata = metadata;
    form.data = data[db.rootTable];
    return form;
};
const buildMetadata = (context, definition, treeLevel)=>{
    const metadata = {
        regvars: {},
        subTables: [],
        terms: {},
        treeLevel: treeLevel,
        vdlists: {}
    };
    context.inca.form.metadata[definition.name] = metadata;
    if (definition.regvars) {
        definition.regvars.forEach((regvar)=>{
            const termId = ++context.termCounter;
            createRegvarForMetadata(metadata, regvar, termId);
            createTermForMetadata(metadata, regvar, termId);
        });
    }
    if (definition.subTables) {
        definition.subTables.forEach((childDefinition)=>{
            buildMetadata(context, childDefinition, treeLevel + 1);
            metadata.subTables.push(childDefinition.name);
        });
    }
};
const buildData = (context, definition)=>{
    const data = {
        id: 1337,
        regvars: {},
        subTables: {},
        vdlists: {}
    };
    definition.regvars.forEach((regvar)=>data.regvars[regvar.shortname] = {
            value: undefined,
            include: true
        });
    definition.subTables.forEach((subTable)=>data.subTables[subTable.name] = []);
    context.inca.form.data = data;
};
const generate = (definition)=>{
    const context = {
        termCounter: 0,
        inca: {
            form: {
                data: {},
                metadata: {}
            }
        }
    };
    buildMetadata(context, definition, 1);
    buildData(context, definition);
    return context.inca;
};
const extendWithRegisterRecordInfo = (inca)=>{
    return merge({}, commonInca, inca);
};
const extendWithSimplifiedErrandInfo = (inca)=>{
    const simplifiedInca = {
        errand: {
            compare: function compare() {
                // eslint-disable-next-line no-console
                console.log('compare');
                return Promise.resolve(true);
            },
            connect: function connect() {
                // eslint-disable-next-line no-console
                console.log('connect');
                return Promise.resolve(true);
            },
            currentPosition: {
                id: 38,
                name: 'OC Demo (0) - SU/Sahlgrenska (500010) - Kirurgen (301)'
            },
            currentRegion: {
                id: 7,
                name: 'Region Demo'
            },
            customButton: function customButton() {
                // eslint-disable-next-line no-console
                console.log('customButton');
            },
            disconnect: function disconnect() {
                // eslint-disable-next-line no-console
                console.log('disconnect');
            },
            errandTags: null,
            importData: function importData() {
                // eslint-disable-next-line no-console
                console.log('importData');
            },
            internalInformation: '',
            print: function print() {
                window.print();
            },
            startSituation: {
                id: null,
                name: null
            }
        },
        form: {
            useSimplifiedErrandType: true
        }
    };
    return merge(simplifiedInca, commonInca, inca);
};
const extendWithErrandInfo = (inca)=>{
    const res = merge({}, commonInca, inca);
    return mergeDescriptors(res, errandInca);
};
const extendWithStartpageInfo = (inca)=>{
    return startpageGenerator(inca);
};
export default {
    generateBasicIncaObjectFromDefinition: generate,
    createDummyForm: createDummyForm,
    createDummyListValues: createDummyListValues,
    extendWithRegisterRecordInfo: extendWithRegisterRecordInfo,
    extendWithErrandInfo: extendWithErrandInfo,
    extendWithStartpageInfo: extendWithStartpageInfo,
    extendWithSimplifiedErrandInfo: extendWithSimplifiedErrandInfo
};
